/* Collection filters + sort (Rene 2026-09-15).
   The markup in snippets/col-filters works on its own as a GET form; this file
   upgrades it to fetch-and-swap through the Section Rendering API so narrowing
   a collection never costs a full page load. Everything it touches degrades to
   the plain form when JS is off or a request fails. */
(function () {
  var form = document.querySelector('[data-cf-form]');
  if (!form || !window.fetch || !window.history) return;

  var sid      = form.dataset.cfSection;
  var gridSel  = '#' + form.dataset.cfGrid;
  var panel    = form.querySelector('[data-cf-panel]');
  var toggle   = form.querySelector('[data-cf-toggle]');
  var chips    = form.querySelector('[data-cf-chips]');
  var badge    = form.querySelector('[data-cf-badge]');
  var reduced  = window.matchMedia('(prefers-reduced-motion: reduce)');
  var seq = 0;

  /* ---------------------------------------------------------------- panel */
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!open));
      panel.hidden = open;
      if (!open) {
        panel.classList.add('is-opening');
        setTimeout(function () { panel.classList.remove('is-opening'); }, 400);
        var first = panel.querySelector('input:not([disabled])');
        if (first && !reduced.matches) first.focus({ preventScroll: true });
      }
    });
    /* A filtered collection opens with the panel already showing: the shopper
       arrived with state, and hiding the controls that produced it is worse
       than the extra height. */
    if (badge && !badge.hidden) toggle.click();
  }

  /* ----------------------------------------------------------- price pair */
  form.querySelectorAll('[data-cf-price]').forEach(function (box) {
    var lo = box.querySelector('[data-cf-lo]'),  hi = box.querySelector('[data-cf-hi]');
    var rl = box.querySelector('[data-cf-rlo]'), rh = box.querySelector('[data-cf-rhi]');
    var fill = box.querySelector('[data-cf-fill]');
    var max = Number(box.dataset.max) || 0;
    if (!lo || !hi || !rl || !rh) return;

    function paint() {
      if (!max) return;
      var a = Math.min(Number(rl.value), Number(rh.value));
      var b = Math.max(Number(rl.value), Number(rh.value));
      fill.style.left  = (a / max * 100) + '%';
      fill.style.width = ((b - a) / max * 100) + '%';
    }
    /* The two thumbs must not cross, or the range reads backwards. */
    function fromRange(which) {
      var a = Number(rl.value), b = Number(rh.value);
      if (a > b) { if (which === 'lo') rl.value = b; else rh.value = a; }
      lo.value = Number(rl.value) > 0 ? rl.value : '';
      hi.value = Number(rh.value) < max ? rh.value : '';
      paint();
    }
    function fromFields() {
      rl.value = lo.value === '' ? 0 : Math.max(0, Math.min(max, Number(lo.value)));
      rh.value = hi.value === '' ? max : Math.max(0, Math.min(max, Number(hi.value)));
      paint();
    }
    rl.addEventListener('input', function () { fromRange('lo'); });
    rh.addEventListener('input', function () { fromRange('hi'); });
    rl.addEventListener('change', apply);
    rh.addEventListener('change', apply);
    lo.addEventListener('input', fromFields);
    hi.addEventListener('input', fromFields);
    lo.addEventListener('change', apply);
    hi.addEventListener('change', apply);
    paint();
  });

  /* --------------------------------------------------------------- submit */
  function url() {
    var data = new FormData(form), qs = new URLSearchParams();
    data.forEach(function (v, k) { if (String(v).trim() !== '') qs.append(k, v); });
    var q = qs.toString();
    return form.getAttribute('action') + (q ? '?' + q : '');
  }

  function busy(on) {
    var grid = document.querySelector(gridSel);
    if (grid) on ? grid.setAttribute('data-cf-busy', '') : grid.removeAttribute('data-cf-busy');
  }

  function go(href) {
    var mine = ++seq;
    busy(true);
    var sep = href.indexOf('?') > -1 ? '&' : '?';
    fetch(href + sep + 'section_id=' + encodeURIComponent(sid), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { if (!r.ok) throw new Error('filter fetch failed'); return r.text(); })
      .then(function (html) {
        if (mine !== seq) return;                 /* a newer click won */
        var doc = new DOMParser().parseFromString(html, 'text/html');
        swap(doc);
        history.pushState({ cf: 1 }, '', href);
        busy(false);
      })
      .catch(function () { window.location.href = href; });   /* never a dead end */
  }

  function apply() { go(url()); }

  function swap(doc) {
    var from = doc.querySelector('[data-cf-results]'), to = document.querySelector('[data-cf-results]');
    if (from && to) to.innerHTML = from.innerHTML;

    var nc = doc.querySelectorAll('[data-cf-count]'), oc = document.querySelectorAll('[data-cf-count]');
    if (nc.length && oc.length) oc.forEach(function (el, i) { el.innerHTML = (nc[i] || nc[0]).innerHTML; });

    var nchips = doc.querySelector('[data-cf-chips]');
    if (nchips && chips) { chips.innerHTML = nchips.innerHTML; chips.hidden = nchips.hidden; }

    var nbadge = doc.querySelector('[data-cf-badge]');
    if (nbadge && badge) { badge.textContent = nbadge.textContent; badge.hidden = nbadge.hidden; }

    /* Counts per value move as other filters narrow the set; the inputs
       themselves are left alone so focus and typing survive the swap. */
    doc.querySelectorAll('.cf-val input').forEach(function (src) {
      var live = form.querySelector('.cf-val input[name="' + src.name + '"][value="' + src.value + '"]');
      if (!live) return;
      var row = live.closest('.cf-val'), n = row && row.querySelector('.cf-valn');
      var srcRow = src.closest('.cf-val'), srcN = srcRow && srcRow.querySelector('.cf-valn');
      if (n && srcN) n.textContent = srcN.textContent;
      live.disabled = src.disabled;
      if (row) row.classList.toggle('is-empty', srcRow.classList.contains('is-empty'));
    });

    document.dispatchEvent(new CustomEvent('kiwi:collection-updated'));
  }

  form.addEventListener('change', function (e) {
    if (e.target.matches('[data-cf-sort], .cf-val input')) apply();
  });
  form.addEventListener('submit', function (e) { e.preventDefault(); apply(); if (panel && toggle && window.innerWidth < 1024) { toggle.click(); } });

  /* Chips, Clear all and pagination are ordinary links — intercepted so they
     swap in place too, and still real hrefs for a new tab or no-JS. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cf-remove], [data-cf-results] nav[aria-label="Pagination"] a');
    if (!a || e.metaKey || e.ctrlKey || e.shiftKey || a.target === '_blank') return;
    e.preventDefault();
    go(a.getAttribute('href'));
    if (a.matches('nav a')) {
      var top = document.querySelector('[data-cf-form]');
      if (top) window.scrollTo({ top: top.getBoundingClientRect().top + scrollY - 120, behavior: reduced.matches ? 'instant' : 'smooth' });
    }
  });

  window.addEventListener('popstate', function () { window.location.reload(); });
})();
